import { render, staticRenderFns } from "./CanshuDetails.vue?vue&type=template&id=3f7106c8"
import script from "./CanshuDetails.vue?vue&type=script&lang=js"
export * from "./CanshuDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports